import * as React from "react";
import { IComponentDataItem } from "../../../../core/types/IComponentDataItem";
import { IFileSystem } from "../../../../dataingestion/types/IFileSystem";
import { IStoragePathItemData } from "../../../../dataingestion/types/IStoragePathItemData";
import { ILookupInstance } from "../../../../lookup/types/ILookup";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { CleanUploadFilesState, addFileToUpload, fileMetadataChanged, setInDropZone, setProgressUploadFileProccess, sortColumn, updatePagination } from "../../../../redux/reducers/DataIngestionReducer";
import { addDroppedFile, cleanDroppedFilesRepertoireState, setEditableFields, setProgressUploadFileRepertoireProccess } from "../../../../redux/reducers/MembersPortalReducer";
import { hideModal, showModal, showUpdateFieldsModal } from "../../../../redux/reducers/ModalReducer";
import { MembersPortalService } from "../../../../redux/services/MembersPortalService";
import { FormatFields } from "../../../../redux/types/FormatFields";
import { IAttachedFile } from "../../../../redux/types/IAttachedFile";
import IDroppedFiles from "../../../../redux/types/IDroppedFiles";
import IMembersPortalComponentDataItem from "../../../../redux/types/IMembersPortalComponentDataItem";
import { IPaginationDetail } from "../../../../redux/types/IPaginationDetail";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { IUsageGroupState } from "../../../../redux/types/IUsageGroupState";
import { DataSource } from "../../../../repertoire/types/DataSource";
import { IRemoveWorkBlobAttachment } from "../../../../repertoire/types/IRemoveWorkBlobAttachment";
import { ITreeData } from "../../../../repertoire/types/ITreeData";
import { MY_DRAFT_CUE_SHEET_PAGE, MY_REGISTERED_CUE_SHEET_PAGE, UPLOAD_CUE_SHEETS_PAGE_VIEW } from "../../../Consts";
import { IMembersPortalField } from "../../../types/IMembersPortalField";

import ScrollEventListenerWrapperContainerDetailsWindow from "../../../../dataingestion/components/containerDetailsWindow/ScrollEventListenerWrapperContainerDetailsWindow";
import InfoToggle from "../../../sharedComponents/button/InfoToggle";
import { IMembersPortalPathInfo } from "../../../types/IMembersPortalPathInfo";

export interface IUploadCueSheetsMaintenanceGeneralDataViewProps {
    UploadCueSheetsMaintenanceGeneralDataViewData: IMembersPortalComponentDataItem;
    dataGridTableData?: IRepertoireComponentDataItem;
    usage: IUsageGroupState;
    isReadOnly: boolean;
    lookupValues: ILookupDictionary;
    editableFields: any[];
    resetMessageBanner: () => void;
    changesMade: boolean;
    showUpdateFieldsModal?: typeof showUpdateFieldsModal;
    editableFieldsDataView?: IMembersPortalComponentDataItem;
    dataGridTableEditableFieldsData?: IMembersPortalComponentDataItem;
    setEditableFields?: typeof setEditableFields;
    activeTab: number;
    tabs: ITabReduxItem[];
    showModal?: typeof showModal;
    hideModal?: typeof hideModal;
    incrementTempID?: () => void;
    activeHeaderSection?: string;
    isMandatory?: boolean;
    uploadCueSheetsMaintenanceGridsViewData: IMembersPortalComponentDataItem;
    addFileToUpload: typeof addFileToUpload;
    cleanUploadFilesState: typeof CleanUploadFilesState;
    containerDetailsWindowComponentData: IComponentDataItem;
    destinations: ILookupInstance[];    
    droppedFiles: IDroppedFiles;
    isDropZone: boolean;
    selectedFileSystem: IFileSystem;
    setInDropZone: typeof setInDropZone;
    setProgressUploadFileProccess: typeof setProgressUploadFileProccess;
    sortColumn: typeof sortColumn;
    storagePathItemData: IComponentDataItem;
    attachedInputFiles: IStoragePathItemData[];
    attachedErrorsFiles: IStoragePathItemData[];
    attachedArchiveFiles: IStoragePathItemData[];
    refreshDirectory: (filesystem: IFileSystem, sources: ITreeData[]) => void;
    addRepertoireAttachmentToState: (attachedFile: IAttachedFile) => void;
    removeWorkAttachmentIfExists: (attachedFile: IAttachedFile, source: DataSource) => void;
    addDroppedFileRepertoire?: typeof addDroppedFile;
    workAttachmentsDropped?: IDroppedFiles;
    cleanDroppedFilesRepertoire: typeof cleanDroppedFilesRepertoireState;
    setProgressUploadFileRepertoire: typeof setProgressUploadFileRepertoireProccess;
    refreshWorkDetails: (dataSource: string, workID: number, lookups: ILookupDictionary, otherIndicatorsWorkFlagTypes: string[], activeTabItem: ITabReduxItem, readonlyIndicatorsWorkFlagTypes: string[], formats?: FormatFields[]) => void;
    dataSource: DataSource;
    paginationDetails: IPaginationDetail[];
    updatePagination: typeof updatePagination;
    getDataIngestionComponentData?: () => void;
    loadMembersPortalFromPath: (pathInfo: IMembersPortalPathInfo, currentUserNameNumber: string, location: Location, tabs?: ITabReduxItem[], lookupValues?: ILookupDictionary) => void;
    currentUserNameNumber: string;   
    setCurrentPage: (link: string) => void;
    addTab: (tab: ITabReduxItem) => void;
}

export default class UploadCueSheetsMaintenanceGeneralDataView extends React.PureComponent<
    IUploadCueSheetsMaintenanceGeneralDataViewProps> {
    viewData;
    constructor(props: IUploadCueSheetsMaintenanceGeneralDataViewProps) {
        super(props);

        this.state = {
            activeHeaderSection: props.activeHeaderSection ?? "draftWorkWorkProperties",
            loaded: false
        };
        this.viewData = {};
    }

    onClickHeaderSection = (activeHeaderSection: string) => {
        this.setState({
            activeHeaderSection
        });
    };

    showFieldsModal = () => {

    }
    
    renderGridViewHeaderSections = (header: IMembersPortalField, isMandatory = false) => {
        return (
            <div
                className={["headerSection", "activeSection", (isMandatory ? "isMandatory" : "")].join(" ")}
                key={header.name}
                data-testid={header.name + "-section"}            >
                {header.data}
            </div>
        );
    };

    refreshWorkDetails() {
        const { tabs, activeTab, lookupValues, dataSource } = this.props;
        let currentTab = tabs[activeTab];
        this.props.refreshWorkDetails(
            dataSource,
            currentTab.workMaintenanceState.work.workID,
            lookupValues,
            tabs[activeTab].otherIndicatorWorkFlagTypes,
            currentTab,
            tabs[activeTab].readonlyIndicatorWorkFlagTypes
        )
    }

    removeAttachmentFromMaintenanceScreen(fullName: string, workId: number, dataSource: DataSource, guid: string, index: number) {
        const attachedFile: IAttachedFile = {
            fileName: fullName,
            workId: workId
        }
        const model: IRemoveWorkBlobAttachment = {
            Guid: guid,
            Source: dataSource,
            workID: workId
        }

        MembersPortalService.removeWorkBlobAttachment(model)
            .then(res => {
                if (res) {
                    MembersPortalService.removeWorkAttachment({ attachedFile: attachedFile, dataSource: dataSource })
                        .then((res: boolean) => {
                            if (res) {
                                this.refreshWorkDetails();
                            }
                        })
                }
            })
    }

    renderForm = () => {
        const {
            lookupValues,
            uploadCueSheetsMaintenanceGridsViewData,
            tabs,
            activeTab,
            addFileToUpload,
            cleanUploadFilesState,
            containerDetailsWindowComponentData,
            destinations,
            droppedFiles,
            isDropZone,
            selectedFileSystem,
            setInDropZone,
            setProgressUploadFileProccess,
            sortColumn,
            storagePathItemData,
            refreshDirectory,
            addRepertoireAttachmentToState,
            removeWorkAttachmentIfExists,
            addDroppedFileRepertoire,
            workAttachmentsDropped,
            cleanDroppedFilesRepertoire,
            setProgressUploadFileRepertoire,
            paginationDetails,
            updatePagination,
            dataSource,
            currentUserNameNumber,
            loadMembersPortalFromPath
        } = this.props;
        const attachedInputFiles = this.props.attachedInputFiles ?? [];
        const attachedErrorsFiles = this.props.attachedErrorsFiles ?? [];
        const attachedArchiveFiles = this.props.attachedArchiveFiles ?? [];

        const infoToggleHeaderField = uploadCueSheetsMaintenanceGridsViewData.fields
            .find(x => x.name === 'infoToggleHeader');

        const infoToggleHtmlField = uploadCueSheetsMaintenanceGridsViewData.fields
            .find(x => x.name === 'infoToggleHTML');


        const renderInfoToggle = (
            <InfoToggle
                headerTextItem={infoToggleHeaderField}
                htmlTextItem={infoToggleHtmlField}
                currentUserNameNumber={currentUserNameNumber}
                lookupValues={lookupValues}
                loadMembersPortalFromPath={loadMembersPortalFromPath}
            />
        )

		const renderDetailsWindowByStorage = (storagePath: IStoragePathItemData[], renderDragFilesUpload: boolean) => {
			return (
				<div className="height">
					{containerDetailsWindowComponentData.fields.length > 0 && (<ScrollEventListenerWrapperContainerDetailsWindow
						addFileToUpload={addFileToUpload}
						cancelChanges={undefined}
						cleanUploadFilesState={cleanUploadFilesState}
						containerDetailsWindowComponentData={
							containerDetailsWindowComponentData
						}
						currentDirectory={"usage"}
						destinations={destinations}
						editingChanged={undefined}
						fileMetadataChanged={fileMetadataChanged}
						jobs={[]}
						matchNow={undefined}
						matchNowSubmit={undefined}
						openDirectory={undefined}
						pageContentIsActive={true}
						distributions={undefined}
						droppedFiles={droppedFiles}
						isDropZone={isDropZone}
						selectedFileSystem={selectedFileSystem}
						setInDropZone={setInDropZone}
						setProgressUploadFileProccess={
							setProgressUploadFileProccess
						}
						storagePathItemData={storagePathItemData}
						storagePaths={storagePath}
						refreshDirectory={refreshDirectory}
						saveChanges={undefined}
						saveState={undefined}
						isRepertoireModule={true}
						toggleSidebarCollapsed={undefined}
						validationMessageChanged={undefined}
						addRepertoireAttachmentToState={
							addRepertoireAttachmentToState
						}
						entityID={1}
						entitySource={dataSource}
						removeAttachmentIfExists={removeWorkAttachmentIfExists}
						addDroppedFileRepertoire={addDroppedFileRepertoire}
						attachmentsDropped={workAttachmentsDropped}
						cleanDroppedFilesRepertoire={cleanDroppedFilesRepertoire}
						setProgressUploadFileRepertoire={
							setProgressUploadFileRepertoire
						}
						component={UPLOAD_CUE_SHEETS_PAGE_VIEW}
						removeAttachmentMaintenanceScreen={this.removeAttachmentFromMaintenanceScreen.bind(
							this,
						)}
						displayRemove={false}
						paginationDetails={paginationDetails}
						updatePagination={updatePagination}
						lookupValues={lookupValues}
						tabs={tabs}
						activeTab={activeTab}
						isProductAttachmentTypeNotRequired={true}
						isProductAttachmentTypeOptional={false}
						isWorkAttachmentTypeNotRequired={true}
						isWorkAttachmentTypeOptional={false}
						currentUserNameNumber={currentUserNameNumber}
						renderDragFilesUpload={renderDragFilesUpload}
						displayResponsiveGrid
					/>)}
					<br></br>
				</div>
			);
		}

        return (
            <>
                <div className="topMargin">
                    <div className="uploadCueSheetInstructions">
                        {renderInfoToggle}
                    </div>
                    <br></br>
                </div>
                <div className="headerContainer" style={{flexDirection:'column'}}>
                    {this.renderGridViewHeaderSections(uploadCueSheetsMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'uploadCueSheetsUploadSectionHeader'), false)}
                    <div className="uploadCueSheetUploadFile" style={{ padding: '10px 15px', fontWeight: 600 }}>
                        {uploadCueSheetsMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'uploadCueSheetsUploadFile').data}
                    </div>
                </div>
                <br></br>
				{renderDetailsWindowByStorage(attachedInputFiles, true)}

                <div className="headerContainer">
                    {this.renderGridViewHeaderSections(uploadCueSheetsMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'uploadCueSheetsErrorsSectionHeader'), false)}
                </div>
                <br></br>
				{renderDetailsWindowByStorage(attachedErrorsFiles, false)}

                <div className="headerContainer">
                    {this.renderGridViewHeaderSections(uploadCueSheetsMaintenanceGridsViewData.fields.find(x => x.name.toString() === 'uploadCueSheetsArchiveSectionHeader'), false)}
                </div>
                <br></br>
				{renderDetailsWindowByStorage(attachedArchiveFiles, false)}
            </>
        );
    }

    render() {       
        return this.renderForm();
    }
}